<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Codici Rifiuto'
    }]"
  />

  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
    </div>
    <div class="self-end">
      <ActionButton
        v-if="authStore.canManagePlatform"
        @click="router.push('/codici-rifiuto/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuovo Codice Rifiuto
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="code"
        >
          Codice
        </SortableColumn>

        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="wasteCode in data"
        :key="'waste-code-table-' + wasteCode.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ wasteCode.code }}
        </td>
        <td class="p-2 text-right" />
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>
    
<script setup>
import {
  PlusCircleIcon,
  TrashIcon
} from "@heroicons/vue/24/outline";
import { ref } from "vue";
import { useRouter } from 'vue-router'

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from '@/composables/datatable.js'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const search = ref('')

const sortStatus = ref(["code", -1]);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/waste-code/list",
  sortStatus,
  search,
  searchProperties: ['code']
})
</script>
